export default __webpack_public_path__ + "atomic/_patterns/03-organisms/ct-content-item--short-listing/_ct-content-item--short-listing.twig";